export default __webpack_public_path__ + "static/media/Saxophone.70fceea8.svg";